export default {
  index: 0,
  complete: [],
  activeSaveButton: false,
}
